import React from 'react'
import ServiceComponent from './ServiceComponent';
import HandsSvg from '../../../svg/HandsSvg';
import ManSvg from '../../../svg/ManSvg';
import { Container, Box, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import SupportSvg from '../../../svg/SupportSvg';
import PhoneNumbersComponent from './PhoneNumbersComponent';
import {  HELP_ROUTE, HOUSE_ROUTE, EDUCATION_ROUTE, WORK_ROUTE } from '../../../routes';
import { useTranslation } from 'react-i18next';
import SchoolSvg from '../../../svg/SchoolSvg';
import HouseIcon from '../../../images/emoji/house.png';
import EducationIcon from '../../../images/emoji/education.png';
import WorkIcon from '../../../images/emoji/work.png';
import PhoneIcon from '../../../images/emoji/phone.png';
import HelpIcon from '../../../images/emoji/help.png';

const useStyles = makeStyles((theme) => ({
    contentContainer: {
        background: '#F5F6FBBA',
        padding: '100px 20px',
        [theme.breakpoints.down('sm')]: {
            padding: '40px 0px',
        },
    },
    paper: {
        marginTop: '80px',
        padding: '40px 10px',
        [theme.breakpoints.down('sm')]: {
            padding: '20px 10px',
            marginTop: '20px',
        },
    },
    phoneTitle: {
        fontSize: '34px',
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            margin: '20px 0',
        },
        [theme.breakpoints.up('sm')]: {
            margin: '0 20px 0 50px',
        },

    },
    emoc: {
        marginLeft: 20,
        width: theme.spacing(6),
        height: 'auto',
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
        },
    },
    phoneContainer: {
        [theme.breakpoints.down('md')]: {
            flexWrap: 'wrap',
        },
        [theme.breakpoints.up('md')]: {
            flexWrap: 'nowrap',
        },
    },
    phones: {
        flex: 1,
        display: 'flex',
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            display: 'block'
        },
    }
}))


const ServicesComponent = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
 
    return (
        <Box className={classes.contentContainer} id='services'>
            <Container>
                <Grid container spacing={2}>
                    <ServiceComponent
                        Icon={SupportSvg}
                        title='help_page'
                        // updated
                        src={HelpIcon}
                        url={HELP_ROUTE}
                        emoc={"👩🏼‍⚕️"}
                    />
                    <ServiceComponent
                        Icon={HandsSvg}
                        src={HouseIcon}
                        title='house_page'
                        url={HOUSE_ROUTE}
                        emoc="🏡"
                    />
                    <ServiceComponent
                        Icon={SchoolSvg}
                        src={EducationIcon} 
                        title='education_page'
                        url={EDUCATION_ROUTE}
                        emoc="👩🏼‍🏫"
                    />
                    <ServiceComponent
                        Icon={ManSvg}
                        src={WorkIcon}
                        title='work_page'
                        url={WORK_ROUTE}
                        emoc="👨🏼‍🔧"
                    />
                </Grid>
                <Paper className={classes.paper} data-aos='fade-up'>
                    <Box display='flex' alignItems='flex-start' justifyContent='center' className={classes.phoneContainer}>
                        <img src={PhoneIcon} alt="contact" className={classes.emoc} />
                        {/* <Box>
                            <SupportSvg />
                        </Box> */}
                        <Typography variant='h2' component='h3' color='primary' className={classes.phoneTitle}>
                            {t('phones.title')}
                        </Typography>
                        <Box display='flex' flexWrap='wrap' className={classes.phones}>
                            <PhoneNumbersComponent
                                title='help_call'
                                content={"help_call_content"}
                            />
                            <PhoneNumbersComponent
                                title='round_the_clock'
                                content={"round_the_clock_content"}
                            />
                            <PhoneNumbersComponent
                                title='reception'
                                content={"reception_content"}
                            />
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Box>
    )
}


export default ServicesComponent;